// TODO; type out the session object

import { create } from "zustand";
import { combine } from "zustand/middleware";

export interface RoleSchema {
  manage_ott: {
    create: boolean;
    read: boolean;
    update: boolean;
    delete: boolean;
  };
}

export interface Role {
  roleID: string;
  roleSchema: RoleSchema;
}

interface User {
  name: string;
  email: string;
  clientID: string;
  userID: string;
  profilePicture: string;
  roles: Role[];
}

type State = {
  user: User;
};

type SetState = {
  setUser: (user: State["user"]) => void;
  setUserRoles: (roles: Role[]) => void;
  clearUser: () => void;
};

const defaultState: State = {
  user: {
    name: "",
    email: "",
    clientID: "",
    userID: "",
    profilePicture: "",
    roles: [],
  },
};

export const useAuthStore = create(
  combine<State, SetState>(defaultState, (set, get) => ({
    setUser(user) {
      set({ user });
    },
    setUserRoles(roles) {
      set((state) => ({
        user: {
          ...state.user,
          roles,
        },
      }));
    },
    clearUser() {
      set(defaultState);
    },
  })),
);
